/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Recurrenceend1Inputs */

const en_entity_recurrenceend1 = /** @type {(inputs: Entity_Recurrenceend1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recurrence End`)
};

const de_entity_recurrenceend1 = /** @type {(inputs: Entity_Recurrenceend1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiederholungsende`)
};

/**
* | output |
* | --- |
* | "Recurrence End" |
*
* @param {Entity_Recurrenceend1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_recurrenceend1 = /** @type {((inputs?: Entity_Recurrenceend1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Recurrenceend1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_recurrenceend1(inputs)
	return de_entity_recurrenceend1(inputs)
});
export { entity_recurrenceend1 as "entity_recurrenceEnd" }